import React, { FC } from 'react'
import { Arrow } from '../../../constants/svg'
import { isExternalURL } from '../../../utils/link.utils'
import { StyledButton, StyledIconButton } from './style'

type Props = {
  icon?: boolean
  iconFile?: any
  iconFileAlt?: string
  target?: '_blank' | '_self'
  alignment?: 'left' | 'center'
  iconAlignment?: 'left' | 'right'
  rel?: string
  className?: string
  ariaLabel?: string
  clickHandler?: any
  href?: string
  text?: string
  size?: 'small' | 'medium' | 'large'
  arrowOrientation?: 'left' | 'right'
  type: 'primary' | 'secondary' | 'tertiary' | 'text-link' | 'icon' | 'inline-text-link'
  theme: 'light' | 'dark' | string
  useCase?: string
  buttonId?: string
}

const Button: FC<Props> = ({
  icon,
  iconFile,
  iconFileAlt,
  target,
  alignment,
  iconAlignment,
  rel,
  className,
  ariaLabel,
  clickHandler,
  href,
  text,
  size,
  arrowOrientation,
  type,
  theme,
  useCase,
  buttonId,
}) => {
  let hrefTarget = target || (href && isExternalURL(href) ? '_blank' : '_self')

  const regularButton = (
    <StyledButton
      data-cy="button"
      className={`CTA ${className ? className : ''}`}
      onClick={clickHandler ? clickHandler : undefined}
      href={href ? href : undefined}
      rel={rel ? rel : 'noopener'}
      target={hrefTarget}
      $size={size}
      $type={type}
      $alignment={alignment}
      $icon={icon}
      $buttonTheme={theme}
      $useCase={useCase || ''}
      id={buttonId ? buttonId : undefined}>
      {iconAlignment === 'left' && icon && iconFile && (
        <div className="CTA__Icon-Container-Left">
          <img src={iconFile} alt={iconFileAlt ? iconFileAlt : 'Icon'} />
        </div>
      )}

      <span>{text}</span>

      {icon && !iconFile && (
        <div className="CTA__Arrow-Container">{type !== 'text-link' && <Arrow />}</div>
      )}

      {icon && iconFile && iconAlignment !== 'left' && (
        <div className="CTA__Arrow-Container">{type !== 'text-link' && iconFile}</div>
      )}
    </StyledButton>
  )

  const iconButton = (
    <StyledIconButton
      data-cy="iconButton"
      color="primary"
      aria-label={ariaLabel ? ariaLabel : 'icon button'}
      className={className ? className : ''}
      onClick={clickHandler}
      disableRipple={true}
      $buttonTheme={theme}
      $arrowOrientation={arrowOrientation ? arrowOrientation : 'left'}>
      <div className="Quote__Slider-Button-Circle">
        <Arrow />
      </div>
    </StyledIconButton>
  )

  //* text-link uses font icon for arrow
  return type !== 'icon' ? regularButton : iconButton
}

export default Button
